export const calculateDisplayPosition = (pdfX, pdfY) => {
  const canvas = document.querySelector(".react-pdf__Page canvas");
  if (!canvas) return { x: 0, y: 0 };

  const rect = canvas.getBoundingClientRect();
  const horizontalOffset = -242;

  const screenX = (pdfX * rect.width) / 595.28 + horizontalOffset;
  const screenY = rect.height - (pdfY * rect.height) / 841.89;

  return { x: screenX, y: screenY };
};

export const calculatePDFCoordinates = (event, canvas) => {
  const rect = canvas.getBoundingClientRect();
  const horizontalOffset = 0;

  const clickX = event.clientX - rect.left - horizontalOffset;
  const clickY = event.clientY - rect.top;

  // Use the same scaling factors as calculateDisplayPosition
  const pdfX = Math.round((clickX * 595.28) / rect.width);
  const pdfY = Math.round(841.89 - (clickY * 841.89) / rect.height);

  return { x: pdfX, y: pdfY };
};

export const generateConfig = (fields, markerMapping) => {
  return {
    fields: fields.map((field) => {
      const baseField = {
        page: field.page,
        type: field.type,
        field: field.name,
        entity: field.entity,
        value_type: field.value_type,
        ...(field.format && { format: field.format }),
        ...(field.spacing && { spacing: field.spacing }),
        // For const value fields
        ...(field.value_type === "const" && {
          value: field.value,
        }),
      };

      if (field.type === "checkbox") {
        return {
          ...baseField,
          checkbox_config: {
            mapping: markerMapping[field.name] || {},
          },
        };
      }

      if (field.type === "list") {
        const mappingKey = `${field.id}_${field.name}`;
        const mapping = markerMapping[mappingKey] || {};
        return {
          ...baseField,
          list_config: {
            mapping: {
              [field.subFieldName]: mapping[field.subFieldName] || [],
            },
          },
        };
      }

      return {
        ...baseField,
        x: field.x,
        y: field.y,
      };
    }),
  };
};
